/**
 * 스냅샷 조회 컨텍스트 (X-As-Of 헤더)
 *
 * 주간/월간 성과보고서처럼 "특정 시점 스냅샷"을 조회하는 화면이 현재 as_of 값을 지정하면,
 * client.ts의 OpenAPI.HEADERS 전역 resolver가 모든 요청에 X-As-Of 헤더를 자동으로 붙인다.
 * (화면 마운트 동안만 세팅하고 언마운트 시 비워, 다른 화면으로 새지 않게 한다.)
 */

let currentAsOf: string | null = null

/** 현재 as_of 설정 (null이면 헤더 미전송) */
export function setCurrentAsOf(asOf: string | null): void {
  currentAsOf = asOf || null
}

/** 현재 as_of 조회 */
export function getCurrentAsOf(): string | null {
  return currentAsOf
}
